export const getCompanyName = (rawData) => {
  const data = rawData?.parent || rawData;

  let companyNameOrOwner = data?.products?.find(({ companyName }) => companyName)?.companyName;

  if (!companyNameOrOwner) {
    companyNameOrOwner = data?.products?.find(({ legalName }) => legalName)?.legalName;
  }

  if (!companyNameOrOwner) {
    companyNameOrOwner = data?.products?.find(({ dbaname }) => dbaname)?.dbaname;
  }

  if (!companyNameOrOwner) {
    let { firstName, lastName } = data?.products?.find(({ owner }) => owner?.firstName)?.owner || {};
    companyNameOrOwner = firstName ? `${firstName} ${lastName}` : 'Company/Owner: not chosen...';
  }

  return companyNameOrOwner;
};

export const getCompanyNameObj = (rawData) => {
  const companyName = getCompanyName(rawData);

  return rawData?.products?.reduce((res, product) => {
    return { ...res, [product.id]: companyName };
  }, {});
};
